
import { Ad } from "@/models/ad";
import { Screen } from "@/models/screen";

export const useSellerStats = (ads: Ad[], screens: Screen[]) => {
  return (sellerId: string) => {
    // Filtramos los anuncios del vendedor
    const sellerAds = ads.filter(ad => ad.sellerId === sellerId);
    
    // Extraemos los IDs de pantallas usadas por el vendedor
    const sellerScreenIds = Array.from(
      new Set(sellerAds.flatMap(ad => ad.screens.map(s => s.screenId)))
    );
    
    // Obtenemos las pantallas utilizadas por el vendedor
    const sellerScreens = screens.filter(screen => sellerScreenIds.includes(screen.id));
    
    // Calculamos las estadísticas
    const totalActiveAds = sellerAds.length;
    const totalOccupiedSpaces = sellerAds.reduce((total, ad) => total + ad.screens.length, 0);
    const totalSpaces = sellerScreens.reduce((total, screen) => total + screen.totalSpaces, 0);
    const totalAvailableSpaces = Math.max(0, totalSpaces - totalOccupiedSpaces);
    
    // Calculamos la ocupación promedio
    const averageOccupancy = totalSpaces > 0
      ? Math.round((totalOccupiedSpaces / totalSpaces) * 100)
      : 0;
    
    return {
      totalActiveAds,
      totalOccupiedSpaces,
      totalAvailableSpaces,
      totalSpaces,
      averageOccupancy,
    };
  };
};
